/** Dev-only (player1): shared mission depth so easy-count tiebreaker is visible. */
export const HONOR_HALL_EXPLORERS_DEV_MOCK_MISSION_DEPTH = 33;

/**
 * Five mock Honor Hall explorers rows — same depth, easy counts 0–4 (ascending rank tiebreaker).
 * @returns {Array<{
 *   rank: number,
 *   username: string,
 *   missions_completed: number,
 *   easy_missions_completed: number,
 *   run_strategy_name: string,
 *   subscribe_strategy_id: null,
 *   is_owned: boolean,
 *   is_subscribed: boolean,
 * }>}
 */
export function buildHonorHallExplorersDevMockRows() {
  const easyCounts = [0, 1, 2, 3, 4];
  return easyCounts.map((easy, index) => ({
    rank: index + 1,
    username: `DevExplorer${index + 1}`,
    missions_completed: HONOR_HALL_EXPLORERS_DEV_MOCK_MISSION_DEPTH,
    easy_missions_completed: easy,
    run_strategy_name: easy === 0 ? 'Normal route' : `Alternative route (${easy} easy)`,
    subscribe_strategy_id: null,
    is_owned: false,
    is_subscribed: false,
  }));
}
